import { gql } from '@apollo/client';

const CHATROOM_FRAGMENT = gql`
  fragment ChatRoomFragment on ChatRoom {
    id
    unreadMessagesCount
    lastMessage {
      id
      message
      from {
        id
        firstName
        lastName
        avatar {
          id
          thumbnailPipeFrom
        }
      }
    }
    appointment {
      notary {
        id
        firstName
        lastName
        avatar {
          id
          thumbnailPipeFrom
        }
      }
      id
      description
      date
      signatoryIds
    }
    chatRelations {
      id
      user {
        avatar {
          id
          thumbnailPipeFrom
        }
        id
        firstName
        lastName
      }
      leftTime
    }
  }
`;

export default CHATROOM_FRAGMENT;
